import { render, staticRenderFns } from "./AuthorSearch.vue?vue&type=template&id=888f9344&scoped=true"
import script from "./AuthorSearch.vue?vue&type=script&lang=js"
export * from "./AuthorSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888f9344",
  null
  
)

export default component.exports